import { useEffect, useState } from 'react';

import * as staffServices from '../../../../../services/staffServices';
import toShort from '../../../../../services/utils/dateParser';

import css from './StaffExperience.module.css';
import { useNavigate } from 'react-router-dom';

function StaffExperience({ id }) {
    const [experience, setExperience] = useState([]);
    const [groupedExperience, setGroupedExperience] = useState({});

    const navigate = useNavigate();

    useEffect(() => {
        staffServices
            .getOption('experience', id)
            .then((result) => {
                result.data.sort((a, b) => new Date(a) - new Date(b));
                setExperience((state) => result.data);
                setGroupedExperience(
                    result.data.reduce((acc, item) => {
                        const date = toShort(item.courseScheduleDate);
                        if (!acc[date]) acc[date] = [];
                        acc[date].push(item);
                        return acc;
                    }, {})
                );
            })
            .catch((error) => {
                console.log(error);
            });
    }, [id]);

    return (
        <div>
            <table className={css.table}>
                <thead className={css.thead}>
                    <th className={css.th}>Date</th>
                    <th className={css.th}>Course</th>
                    <th className={css.th}>Subject</th>
                    <th className={css.th}>Aircraft</th>
                </thead>
                {/* <tbody className={css.tbody}>
                    {experience.map(x => (
                        <tr key={experience.courseScheduleId} className={css.tr}>
                            <td className={css.td}>{toShort(x.courseScheduleDate)}</td>
                            <td className={css.td}>({x.courseNo}) {x.courseTitle}</td>
                            <td className={css.td}>{x.ataNo} {x.ataTitle}</td>
                        </tr>
                    ))}
                </tbody> */}
                {Object.entries(groupedExperience).map(([date, rows]) =>
                    rows.map((row, index) => (
                        <tr key={row.courseScheduleId} className={css.tr}>
                            {/* Render Date Cell only for the first row in the group */}
                            {index === 0 && (
                                <td className={css.td} rowSpan={rows.length}>
                                    {date}
                                </td>
                            )}
                            <td className={css.tdLink} onClick={() => navigate(`/course/details/${row.courseId}`)}>
                                ({row.courseNo}) {row.courseTitle}
                            </td>
                            <td className={css.td}>
                                {row.ataNo} {row.ataTitle}
                            </td>
                            <td className={css.td}>
                                {row.aircraftTypeTitleShort}
                            </td>
                        </tr>
                    ))
                )}
            </table>
        </div>
    );
}

export default StaffExperience;
